
import React from 'react';

import { withUAPLThemedStyles } from '../../with-themed-styles';
import { AdPlacementLinkedInSingleImageBase } from './li-single-image-ad-placement-base';
import {
  getLinkedInSingleImageDesktopStyles,
  getLinkedInSingleImageMobileStyles,
  getLinkedInSingleImageMediumRectangleStyles,
  getLinkedInSingleImageMobileInterstitialStyles,
  getLinkedInSingleImageNativeStyles,
} from '../../styles';


export const AdPlacementLinkedInSingleImageDesktop = withUAPLThemedStyles(
  props => (
    <AdPlacementLinkedInSingleImageBase
      showHeader
      showIntroductoryText
      showFooter
      showCompanyInFooter={false}
      showfinalUrl
      {...props}
    />),
  getLinkedInSingleImageDesktopStyles,
  { componentName: 'AdPlacementLinkedInSingleImageDesktop' }
);

export const AdPlacementLinkedInSingleImageMobile = withUAPLThemedStyles(
  props => (
    <AdPlacementLinkedInSingleImageBase
      showHeader
      showIntroductoryText
      showFooter
      showCompanyInFooter={false}
      showfinalUrl
      {...props}
    />
  ),
  getLinkedInSingleImageMobileStyles,
  { componentName: 'AdPlacementLinkedInSingleImageMobile' }
);

export const AdPlacementLinkedInSingleImageMediumRectangle = withUAPLThemedStyles(
  props => (
    <AdPlacementLinkedInSingleImageBase
      showHeader={false}
      showIntroductoryText={false}
      showFooter
      showCompanyInFooter
      showfinalUrl={false}
      {...props}
    />
  ),
  getLinkedInSingleImageMediumRectangleStyles,
  { componentName: 'AdPlacementLinkedInSingleImageMediumRectangle' }
);

export const AdPlacementLinkedInSingleImageMobileInterstitial = withUAPLThemedStyles(
  props => (
    <AdPlacementLinkedInSingleImageBase
      showHeader={false}
      showIntroductoryText={false}
      showFooter
      showIntroductoryTextInFooter
      showCompanyInFooter
      showfinalUrl={false}
      {...props}
    />
  ),
  getLinkedInSingleImageMobileInterstitialStyles,
  { componentName: 'AdPlacementLinkedInSingleImageMobileInterstitial' }
);

export const AdPlacementLinkedInSingleImageNative = withUAPLThemedStyles(
  props => (
    <AdPlacementLinkedInSingleImageBase
      showHeader
      showIntroductoryText
      showFooter
      showCompanyInFooter={false}
      showfinalUrlInFooter={false}
      showIntroductoryTextInFooter={false}
      showfinalUrl={false}
      {...props}
    />
  ),
  getLinkedInSingleImageNativeStyles,
  { componentName: 'AdPlacementLinkedInSingleImageNative' }
);
